import { ApplicationConfig } from '@angular/core';
import { provideRouter, RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { routes } from './app.routes';
import { environment } from '../../environments/environment';
import { CustomRouteReuseStrategy } from './route-reuse-strategy';
import { TokenResolverService } from './services/token-resolver.service';
import { importProvidersFrom } from '@angular/core';
import { MarkdownModule } from 'ngx-markdown';

export const appConfig: ApplicationConfig = {
  providers: [
    TokenResolverService,
    provideRouter(routes),
    provideHttpClient(),
    { provide: 'API_URL', useValue: environment.API_URL },
    { provide: RouteReuseStrategy, useClass: CustomRouteReuseStrategy },
    importProvidersFrom(MarkdownModule.forRoot())
  ]
};
